export default {
  DEMO: 'DEMO',
  NO_ADS: 'NO_ADS',
  TESTER: 'TESTER',
  VIEWER: 'VIEWER',
};
